"use client";

import Link from "next/link";
import {Typography} from "@repo/ui/aops-components/typography";
import {sendDiscoveryEventBeacon} from "@/lib/discoveryEventBeacon";

export type CartCourseLinkTrackingProps = {
	course_id: string;
	course_name: string;
	campus_id?: string;
	modality?: string;
	part?: string;
};

/**
 * Fire the Discovery beacon for a cart course-page link click.
 */
export function trackCartCourseLinkClicked(
	props: CartCourseLinkTrackingProps
): void {
	sendDiscoveryEventBeacon("course_page_link_clicked", {
		course_id: props.course_id,
		course_name: props.course_name,
		campus_id: props.campus_id ?? "",
		modality: props.modality ?? "",
		part: props.part ?? "",
	});
}

type CartCourseLinkProps = {
	href: string;
	className?: string;
	tracking: CartCourseLinkTrackingProps;
	children: string;
};

/**
 * Course title link in the cart that tracks `course_page_link_clicked` on click.
 */
export function CartCourseLink({
	href,
	className,
	tracking,
	children,
}: CartCourseLinkProps) {
	return (
		<Link
			href={href}
			className={className}
			onClick={() => trackCartCourseLinkClicked(tracking)}
		>
			<Typography variant="h5">{children}</Typography>
		</Link>
	);
}
